import React, { FC } from 'react';
import { Card, Container } from '@mui/material';
import { DashboardHeader } from "../../../../UIKit/DashboardHeader";
import {TextInput} from "../../../../UIKit/TextInput";
import { useUiContext } from "../../../../UIProvider";
import { observer } from 'mobx-react-lite';
import { useMagazineCategoryEditing } from '../../presenters/useMagazineCategoryEditing';

export const MagazineCategoryEditingView: FC = observer(() => {
    const { t } = useUiContext();
    const { magazineCategory, errors, onChange, onUpdateMagazineCategory, loading } = useMagazineCategoryEditing();

    return (
        <Container>
            <DashboardHeader 
                title={t("magazineCategory.editMagazineCategory")} 
                buttonTitle={t("common.save")} 
                onPress={onUpdateMagazineCategory}
            />
            <Card sx={{ p: 2, mb: 2 }}>
                <TextInput label={t('common.name')} name='name' onChange={onChange} value={magazineCategory?.name} error={errors} required />
                <TextInput label={t('common.description')} name='description' onChange={onChange} value={magazineCategory?.description} error={errors} isMultiline minRows={3} required />
            </Card>
        </Container>
    );
});
